import { CandidateInformation } from '@models/candidate/candidate-information';
import { EventManager } from '@models/event/event-manager';
import { OpsEvent, toOpsEvent } from '@models/event/ops-event';

export interface CandidateAppResponse {
  event: OpsEvent;
  candidate: CandidateInformation;
  initiativeTitle: string | null;
  initiativeDescription: string | null;
  eventManagers: EventManager[];
}

export function toCandidateAppResponse(data: CandidateAppResponse): CandidateAppResponse {
  return {
    ...data,
    event: toOpsEvent(data.event),
  };
}
